import React from 'react'
import { StaffBenefitForm } from './StaffBenefitForm'
import { TableRow, TableCell, Collapse, Container, Box } from '@mui/material'

export const EditStaffBenefit = (props) => {
  const { row, editing, setEditing } = props
  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
        <Collapse in={editing} timeout='auto' unmountOnExit>
          <Container maxWidth='md' margin={4}>
            <Box margin={4}>
              <StaffBenefitForm row={row} editing={editing} setEditing={setEditing} />
            </Box>
          </Container>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}
